module.exports = __webpack_public_path__ + "img/merchant-home-dtewm.c349d57a.png";